import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataUser(params) {
	return client.get("api/user-supplier/data", {
		params: params,
	});
}

function exportUser(params) {
	return client.get("api/user-supplier/export", {
		params: params,
	});
}

function getOptionType() {
	return client.get("api/options/user-type");
}

function addUser(params) {
	return client.post("api/user-supplier/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateUser(params) {
	return client.post("api/user-supplier/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteUser(params) {
	return client.post("api/user-supplier/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusUser(params) {
	return client.post("api/user-supplier/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updatePasswordSupplier(params) {
	return client.post("api/user-supplier/edit-password-all", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataUser,
	exportUser,
	addUser,
	updateUser,
	deleteUser,
	statusUser,
	getOptionType,
	updatePasswordSupplier,
};